import { Link } from "react-router-dom";
import { ArrowRight, ExternalLink } from "lucide-react";

// Solid red call-to-action band. Use sparingly for high-emphasis CTAs.
export const RedBand = ({ eyebrow, title, text, primary, secondary, testid = "red-band" }) => {
  const renderBtn = (b, variant) => {
    if (!b) return null;
    const cls =
      variant === "primary"
        ? "inline-flex items-center justify-center gap-2 rounded-md bg-white px-7 py-3.5 text-sm font-semibold uppercase tracking-wide text-[hsl(var(--brand-red-deep))] transition-colors duration-200 hover:bg-white/90 active:scale-[0.98]"
        : "inline-flex items-center justify-center gap-2 rounded-md border border-white/60 bg-transparent px-7 py-3.5 text-sm font-semibold uppercase tracking-wide text-white transition-colors duration-200 hover:bg-white/10 active:scale-[0.98]";
    if (b.to) return <Link to={b.to} data-testid={`${testid}-${variant}`} className={cls}>{b.label} <ArrowRight className="h-4 w-4" /></Link>;
    return (
      <a href={b.href} target="_blank" rel="noopener noreferrer" data-testid={`${testid}-${variant}`} className={cls}>
        {b.label} <ExternalLink className="h-4 w-4" />
      </a>
    );
  };

  return (
    <section
      data-testid={testid}
      className="relative overflow-hidden bg-[hsl(var(--brand-red))] py-14 text-white sm:py-16"
      style={{ backgroundImage: "linear-gradient(135deg, hsl(var(--brand-red)) 0%, hsl(var(--brand-red-deep)) 100%)" }}
    >
      <div className="mx-auto flex w-full max-w-5xl flex-col items-center px-4 text-center sm:px-6">
        {eyebrow && <div className="font-condensed text-xs font-semibold uppercase tracking-[0.25em] text-white/80">{eyebrow}</div>}
        <h2 className="mt-2 display-title text-4xl sm:text-5xl">{title}</h2>
        {text && <p className="mt-3 max-w-2xl text-base text-white/85">{text}</p>}
        {(primary || secondary) && (
          <div className="mt-7 flex flex-col gap-3 sm:flex-row">
            {renderBtn(primary, "primary")}
            {renderBtn(secondary, "secondary")}
          </div>
        )}
      </div>
    </section>
  );
};
